import { BaseInternalFormFactory } from "../../base-internal-form/base-internal-form-factory"
import { EnvioRemessaProvider } from "./context/envio-remessa-context"
import { EnvioRemessa } from "./envio-remessa"

export const EnvioRemessaFactory = () => {
    return (  <BaseInternalFormFactory pageTitle="Envio de Remessa">
    <EnvioRemessaProvider>
        <EnvioRemessa />
    </EnvioRemessaProvider>
</BaseInternalFormFactory>)
}